/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Test-outcomes panel (035 US4) — the standing-check analog of 034's Top-types panel,
 * on the shared au-panel/au-card system. Standing Check has no free-text "type" column;
 * instead it shows two blocks over the filtered set:
 *   (a) Completed vs Aborted — count + % share of Total Records
 *   (b) Platform mix (iOS / Android / (unknown)) — count + % share, order as returned
 * All figures are text + value (never colour alone), with tabular numerals. "%" is
 * computed client-side against Total Records ("—" when Total Records is 0).
 *
 * Props: {
 *   outcomes:{ completed, aborted },
 *   platforms:[{ platform, platform_count }],
 *   totalRecords:number
 * }
 */
const n = (v) => Number(v || 0).toLocaleString();

const pctShare = (count, total) => {
  if (!total || total <= 0) return '—';
  const p = (Number(count) / total) * 100;
  return p < 1 ? '<1%' : `${Math.round(p)}%`;
};

const StandingCheckOutcomesPanel = ({
  outcomes = { completed: 0, aborted: 0 },
  platforms = [],
  totalRecords = 0,
}) => (
  <div className="au-panel" data-testid="sc-outcomes">
    <div className="au-panel__head">
      <h4 className="au-panel__title">Test outcomes</h4>
    </div>
    <div className="sc-outcomes">
      {/* (a) Completed vs Aborted */}
      <div className="sc-outcomes__section">
        <p className="sc-outcomes__block-title">Completed vs Aborted</p>
        <ul className="sc-outcomes__list">
          <li className="sc-outcomes__row" data-testid="sc-outcome-completed">
            <span className="sc-outcomes__name">Completed</span>
            <span className="sc-outcomes__count tnum">{n(outcomes.completed)}</span>
            <span className="sc-outcomes__pct tnum">{pctShare(outcomes.completed, totalRecords)}</span>
          </li>
          <li className="sc-outcomes__row" data-testid="sc-outcome-aborted">
            <span className="sc-outcomes__name">Aborted</span>
            <span className="sc-outcomes__count tnum">{n(outcomes.aborted)}</span>
            <span className="sc-outcomes__pct tnum">{pctShare(outcomes.aborted, totalRecords)}</span>
          </li>
        </ul>
      </div>

      {/* (b) Platform mix */}
      <div className="sc-outcomes__section">
        <p className="sc-outcomes__block-title">Platform mix</p>
        {Array.isArray(platforms) && platforms.length > 0 ? (
          <ul className="sc-outcomes__list">
            {platforms.map((p) => (
              <li key={p.platform} className="sc-outcomes__row">
                <span className="sc-outcomes__name au-ellipsis">{p.platform}</span>
                <span className="sc-outcomes__count tnum">{n(p.platform_count)}</span>
                <span className="sc-outcomes__pct tnum">{pctShare(p.platform_count, totalRecords)}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="au-chart-empty" data-testid="sc-outcomes-platforms-empty">
            No platform data in this range.
          </div>
        )}
      </div>
    </div>
  </div>
);

export default StandingCheckOutcomesPanel;
